module.exports = __webpack_public_path__ + "e70c88af8efc41619d9955c4dee579a7.pdf";